/**
 * Route prefixes where the topbar suppresses its promotional CTAs (Go Plus) —
 * the page is already an upgrade or creator surface.
 */
export const CTA_SUPPRESSED_PATH_PREFIXES = ["/upgrade", "/creators"];

/**
 * Catalog surfaces — the browse feeds. Everything else (search, library, a
 * calendar's timeline, checkout, settings, marketing) is content the sidebar
 * only competes with, so it starts collapsed there.
 */
const CATALOG_PATHS = ["/", "/explore", "/sections", "/tag", "/movies"];

/**
 * True when the path is a catalog browse surface.
 *
 * Matching is an allowlist because the timeline routes (`/:handle`) would
 * otherwise swallow every path.
 *
 * @param {string} pathname
 * @returns {boolean}
 */
export function isCatalogPath(pathname) {
  if (!pathname) return false;
  if (pathname === "/") return true;
  return CATALOG_PATHS.some(
    (base) => base !== "/" && (pathname === base || pathname.startsWith(`${base}/`)),
  );
}

/**
 * Decides whether the sidebar should be collapsed for the path just entered.
 *
 * Leaving the catalog collapses it; entering the catalog from outside opens it.
 * Moving between catalog pages keeps whatever the user last chose, so a manual
 * collapse survives browsing.
 *
 * @param {{ isCatalog: boolean, wasCatalog: boolean|null, stored: boolean }} params
 *   `wasCatalog` is null on a fresh session (direct landing or reload).
 * @returns {boolean}
 */
export function resolveCollapsed({ isCatalog, wasCatalog, stored }) {
  if (!isCatalog) return true;
  if (wasCatalog === true) return stored;
  return false;
}
